var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.info.icon,{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.info.text),expression:"info.text"}],tag:"component",staticClass:"flex-shrink-0",class:_vm.classes})}
var staticRenderFns = []

export { render, staticRenderFns }